import React, { Fragment } from 'react'
import "./loading.css"

const Loader = () => {
  return (
    <Fragment>
      <section className="flex w-[100vw] h-[100vh] fixed z-[999999999] justify-center items-center top-0 left-0 bg-white">

        <div className="relative flex items-center justify-center">

         <div class="loading">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>

        </div>

      </section>
    </Fragment>
  )
}

export default Loader